import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__ from "@orbit-ui/core";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
const Card = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, ...properties }, reference)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        ref: reference,
        className: (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.cn)('rounded-lg border bg-card text-card-foreground shadow-sm', className),
        ...properties
    }));
Card.displayName = 'Card';
const CardHeader = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, ...properties }, reference)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        ref: reference,
        className: (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.cn)('flex flex-col space-y-1.5 p-6', className),
        ...properties
    }));
CardHeader.displayName = 'CardHeader';
const CardTitle = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, children, ...properties }, reference)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("h3", {
        ref: reference,
        className: (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.cn)('text-lg font-semibold leading-none tracking-tight', className),
        ...properties,
        children: children
    }));
CardTitle.displayName = 'CardTitle';
const CardDescription = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, ...properties }, reference)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("p", {
        ref: reference,
        className: (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.cn)('text-sm text-muted-foreground', className),
        ...properties
    }));
CardDescription.displayName = "CardDescription";
const CardContent = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, ...properties }, reference)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        ref: reference,
        className: (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.cn)('p-6 pt-0', className),
        ...properties
    }));
CardContent.displayName = 'CardContent';
const CardFooter = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, ...properties }, reference)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        ref: reference,
        className: (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.cn)(' flex items-center p-6 pt-0', className),
        ...properties
    }));
CardFooter.displayName = 'CardFooter';
export { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle };

//# sourceMappingURL=index.js.map